module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_f-f1978de4c2849b95f09bac4d7a797082.png";